<template>
	<label>
		<div
			class="checkbox"
			:class="{ checked: effectiveValue, disabled, indeterminate: indeterminate && !effectiveValue }"
		>
			<input type="checkbox" :checked="effectiveValue" :disabled="disabled" @change="onChange" @click.stop />
			<span class="checkbox-icon">
				<svg v-if="effectiveValue" class="checkmark" viewBox="0 0 24 24">
					<path fill="currentColor" d="M9 16.2l-3.5-3.5L4 14.2l5 5 12-12-1.5-1.5z" />
				</svg>
				<svg v-if="indeterminate && !effectiveValue" class="checkmark" viewBox="0 0 24 24">
					<path
						fill="currentColor"
						d="M6 12h12"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
					/>
				</svg>
			</span>
		</div>
		<span class="checkbox-label" v-if="label">{{ label }}</span>
	</label>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
	label?: string;
	modelValue?: boolean;
	disabled?: boolean;
	indeterminate?: boolean;
}>();

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void;
}>();

const effectiveValue = computed(() => props.modelValue ?? false);

function onChange(e: Event) {
	const target = e.target as HTMLInputElement | null;
	emit('update:modelValue', Boolean(target?.checked));
}
</script>
<style lang="scss" scoped>
label {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	--color-checked: #fbc500;
	--color-not-checked: #263642;

	.checkbox {
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		width: 18px;
		height: 18px;
		border-radius: 2px;
		border: 2px solid;
		transition: all 0.2s ease;
		user-select: none;

		input {
			opacity: 0;
			position: absolute;
			cursor: pointer;
		}

		.checkbox-icon {
			position: absolute;
			display: flex;
			align-items: center;
			justify-content: center;
			pointer-events: none;
		}

		&.checked,
		&.indeterminate {
			background-color: var(--color-checked);
			border-color: var(--color-checked);
			color: black;
		}

		&:not(.checked):not(.indeterminate) {
			border-color: var(--color-not-checked);
		}

		&.disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		.checkmark {
			width: 18px;
			height: 18px;
		}
	}
}
</style>
